import { defineBool } from '@spotify-internal/remote-config-properties';

export const presaveRollout = defineBool({
  name: 'presave-rollout',
  description: 'Rollout feature flag for presave',
  default: false,
});

export const unclearedMusicVideosRollout = defineBool({
  name: 'uncleared-music-videos-rollout',
  description:
    'Rollout feature flag for uncleared music videos tab and features.',
  default: false,
});

export const newAvailabilityRollout = defineBool({
  name: 'new-availability',
  description: 'Enable availability from shared capabilities',
  default: false,
});

export const registeredArtistTextRollout = defineBool({
  name: 'registered-artist-text-rollout',
  description:
    'Show "Registered" text instead of verified checkmark icon for registered artists',
  default: false,
});

export const profileProtectionsRollout = defineBool({
  name: 'profile-protections-rollout',
  description: 'Rollout feature flag for profile protections tab.',
  default: false,
});

export const contributorCreditsRollout = defineBool({
  name: 'contributor-credits-rollout',
  description:
    'Enable page 2 of the content relocation form with dynamic contributor credits lookup.',
  default: false,
});

export const profileProtectionExtendedBeta = defineBool({
  name: 'profile-protection-extended-beta',
  description: 'Feature flag for extended beta profile protection changes.',
  default: false,
});

export const properties = [
  presaveRollout,
  unclearedMusicVideosRollout,
  newAvailabilityRollout,
  registeredArtistTextRollout,
  profileProtectionsRollout,
  contributorCreditsRollout,
  profileProtectionExtendedBeta,
];
